import { ComponentType, JSX, useMemo } from 'react';

import { FeatureFlaggedProps } from '@backstage/core-app-api';

import { useFlag } from '@spotify-confidence/react';
import { Value } from '@spotify-confidence/sdk';

import { useLocalOverride } from './overrideStore';

// If we wanna use the original FeatureFlagged component,
// we should re-export it from @backstage/core-app-api
// export { FeatureFlagged } from '@backstage/core-app-api';

export const useFeatureFlag = <T extends Value>(
  flag: string,
  defaultValue: T,
): T => useLocalOverride(flag, useFlag(flag, defaultValue));

export const FeatureFlagged = (props: FeatureFlaggedProps) => {
  const flag = 'with' in props ? props.with : props.without;
  const desired = 'with' in props;
  const { enabled } = useFeatureFlag(flag, { enabled: false });
  return <>{enabled === desired ? props.children : null}</>;
};

export const splitComponent = <
  V extends Value.Struct,
  P extends JSX.IntrinsicAttributes,
>(
  flag: string,
  defaultValue: V,
  factory: (value: V) => ComponentType<P>,
) => {
  return (props: P) => {
    const value = useFeatureFlag(flag, defaultValue);
    const Component = useMemo(
      () => (value ? factory(value as V) : null),
      [value],
    );
    if (!Component) {
      return null;
    }

    return <Component {...props} />;
  };
};
